export interface Testimonial {
  id: string;
  name: string;
  role: string;
  company: string;
  avatar: string;
  rating: number;
  quote: string;
  shipments: number;
}

export const TESTIMONIALS: Testimonial[] = [
  {
    id: '1',
    name: 'Rebecca Thornton',
    role: 'Supply Chain Director',
    company: 'NovaMed Healthcare',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20confident%20woman%20in%20her%2040s%20with%20brown%20hair%2C%20business%20attire%2C%20warm%20smile%2C%20clean%20white%20background%2C%20studio%20lighting%2C%20corporate%20portrait%20photography&width=100&height=100&seq=t1&orientation=squarish',
    rating: 5,
    quote: 'SwiftTrack has transformed how we manage medical supply deliveries. The real-time tracking and instant status updates give us the confidence to promise hospitals exactly when their supplies will arrive. Absolutely game-changing.',
    shipments: 1240,
  },
  {
    id: '2',
    name: 'Marcus Williams',
    role: 'Founder & CEO',
    company: 'Craft & Co. Artisan Shop',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20young%20black%20man%20in%20his%2030s%2C%20casual%20business%20shirt%2C%20friendly%20confident%20smile%2C%20clean%20light%20background%2C%20studio%20portrait%20photography&width=100&height=100&seq=t2&orientation=squarish',
    rating: 5,
    quote: 'As a small business owner, reliable shipping is everything. SwiftTrack gives me the same logistics power that big corporations have. My customers always know exactly where their orders are — and they love it.',
    shipments: 380,
  },
  {
    id: '3',
    name: 'Priya Sharma',
    role: 'Operations Manager',
    company: 'GlobalTech Imports',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20an%20Indian%20woman%20in%20her%2030s%2C%20elegant%20business%20attire%2C%20confident%20expression%2C%20clean%20neutral%20background%2C%20studio%20portrait%20photography&width=100&height=100&seq=t3&orientation=squarish',
    rating: 5,
    quote: 'We ship internationally and tracking across multiple carriers was a nightmare before SwiftTrack. Now everything is in one dashboard. The route optimization alone has saved us thousands per month in logistics costs.',
    shipments: 2890,
  },
  {
    id: '4',
    name: 'James O\'Brien',
    role: 'Logistics Coordinator',
    company: 'Pacific Steel Works',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20middle-aged%20white%20man%20with%20short%20hair%2C%20business%20casual%20shirt%2C%20friendly%20smile%2C%20clean%20background%2C%20corporate%20portrait%20photography&width=100&height=100&seq=t4&orientation=squarish',
    rating: 4,
    quote: 'Handling heavy freight shipments across state lines requires precision. SwiftTrack\'s live map feature and hold notifications mean we never miss a critical delay. The customer service is also top-tier.',
    shipments: 670,
  },
  {
    id: '5',
    name: 'Sofia Marchetti',
    role: 'E-commerce Director',
    company: 'Bella Casa Home Goods',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20an%20Italian%20woman%20in%20her%20late%2020s%2C%20stylish%20appearance%2C%20bright%20smile%2C%20clean%20white%20studio%20background%2C%20fashion%20professional%20portrait&width=100&height=100&seq=t5&orientation=squarish',
    rating: 5,
    quote: 'Our online store ships hundreds of packages daily. SwiftTrack handles everything seamlessly — from pickup confirmation to delivery proof. Our customer return rate dropped by 40% after switching to SwiftTrack.',
    shipments: 5100,
  },
  {
    id: '6',
    name: 'David Okafor',
    role: 'Regional Manager',
    company: 'FreshFarm Organics',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20Nigerian%20man%20in%20his%2040s%2C%20wearing%20a%20suit%2C%20serious%20professional%20expression%2C%20clean%20office%20background%2C%20corporate%20business%20portrait%20photography&width=100&height=100&seq=t6&orientation=squarish',
    rating: 5,
    quote: 'Perishable goods shipping requires exact timing. SwiftTrack\'s express tier and real-time alerts ensure our organic produce arrives fresh. I cannot imagine running our distribution network without this platform.',
    shipments: 920,
  },
];
